const confirmEmailAndActivateAccountPage = (code: string): string =>
  `/confirmEmailAndActivateAccount/${code}`;

const resetPasswordPage = (hash: string): string => `/resetPassword/${hash}`;

const joinToCoursePage = (joinCode: string): string => `/j/${joinCode}`;

const courseSettingsPage = (id: string): string => `/course/${id}/settings`;

const coursePage = (id: string): string => `/course/${id}`;

export const urls = {
  homePage: '/',
  loginPage: '/login',
  registrationPage: '/registration',
  confirmEmailAndActivateAccountPage,
  forgotPasswordPage: '/forgotPassword',
  resetPasswordPage,
  joinToCoursePage,
  courseSettingsPage,
  coursePage,
  createCoursePage: '/courses/create',
  healthStatusPage: '/health',
  regulationsPage: '/regulations',
  privacyPolicyPage: '/privacyPolicy',
  unauthorizedPage: '/401',
  forbiddenPage: '/403',
  notFoundPage: '/404',
  treneoSite: 'https://treneo.pl'
};
